<template>
  <div class="modify-strain">
    <el-dialog
      :title="titleName"
      :visible.sync="dialogVisible"
      width="900px"
      top="15px"
      @close="closeWindow"
    >
      <el-form :model="form" label-position="top">
        <h3>essential information</h3>
        <el-row>
          <el-col :span="12">
            <el-form-item class="mar-right" :label-width="formLabelWidth">
              <span slot="label" class="require">Strain name</span>
              <el-input
                v-model="form.strainName"
                autocomplete="off"
                placeholder="Please enter Strain name"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item class="mar-left" :label-width="formLabelWidth">
              <span slot="label" class="require">seqId</span>
              <el-input
                v-model="form.serialCode"
                autocomplete="off"
                placeholder="Please enter seqId"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <h3 class="mar-top">
          sequence
          <el-tooltip
            class="item"
            effect="dark"
            content="此操作不可取消"
            placement="top"
          >
            <svg
              t="1647932228140"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="4861"
              width="16"
              height="16"
            >
              <path
                d="M512 64a448 448 0 1 0 448 448 448 448 0 0 0-448-448z m3.2 704a48 48 0 0 1-48-47.36 48.64 48.64 0 0 1 48-48 48 48 0 0 1 47.36 48 47.36 47.36 0 0 1-47.36 47.36z m80.64-271.36A131.84 131.84 0 0 0 547.84 576v32a33.28 33.28 0 0 1-64 0v-24.32a181.76 181.76 0 0 1 67.2-120.32 165.76 165.76 0 0 0 60.16-104.96 83.2 83.2 0 0 0-90.24-89.6c-64 0-99.84 41.6-101.76 119.68a32 32 0 0 1-31.36 28.8 31.36 31.36 0 0 1-30.72-28.8V384a154.24 154.24 0 0 1 163.84-166.4 135.04 135.04 0 0 1 147.2 140.8 196.48 196.48 0 0 1-72.32 138.24z"
                p-id="4862"
              ></path>
            </svg>
          </el-tooltip>
        </h3>
        <el-row>
          <el-col :span="8">
            <el-form-item
              :label-width="formLabelWidth"
              class="sequence mar-right"
            >
              <div slot="label" style="width:200px">
                <span>genomic</span>
              </div>
              <el-upload
                class="upload-demo"
                action="/"
                :auto-upload="false"
                :on-change="fileHandleChange"
                :show-file-list="false"
                :disabled="
                  loading.genomeSequence || form.genomeSequence.length !== 0
                "
                :accept="suffixList[0]"
              >
                <div
                  class="sequence-item"
                  :class="{ fontColor: form.genomeSequence }"
                >
                  <div
                    class="sequence-item-loading"
                    v-if="loading.genomeSequence"
                  >
                    <span>文件上传中</span>
                    <i class="el-icon-loading"></i>
                  </div>
                  <div class="text-item" v-if="!loading.genomeSequence">
                    <span>{{ form.genomeSequence || suffixList[0] }}</span>
                    <i
                      v-if="form.genomeSequence"
                      @click.stop="delSequence('genomeSequence')"
                      class="el-icon-close"
                    ></i>
                  </div>
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="cds"
              :label-width="formLabelWidth"
              class="sequence mar-right mar-left"
            >
              <el-upload
                class="upload-demo"
                action="/"
                :auto-upload="false"
                :on-change="fileHandleChange"
                :show-file-list="false"
                :disabled="loading.gdsSequence || form.gdsSequence.length !== 0"
                accept=".cds.fna.tar.gz,.ffn.tar.gz"
              >
                <div
                  class="sequence-item"
                  :class="{ fontColor: form.gdsSequence }"
                >
                  <div class="sequence-item-loading" v-if="loading.gdsSequence">
                    <span>文件上传中</span>
                    <i class="el-icon-loading"></i>
                  </div>
                  <div class="text-item" v-if="!loading.gdsSequence">
                    <span>{{
                      form.gdsSequence || '.cds.fna.tar.gz或.ffn.tar.gz'
                    }}</span>
                    <i
                      v-if="form.gdsSequence"
                      class="el-icon-close"
                      @click.stop="delSequence('gdsSequence')"
                    ></i>
                  </div>
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="protein"
              :label-width="formLabelWidth"
              class="sequence mar-left"
            >
              <el-upload
                class="upload-demo"
                action="/"
                :auto-upload="false"
                :on-change="fileHandleChange"
                :show-file-list="false"
                :disabled="
                  loading.proteinSequence || form.proteinSequence.length !== 0
                "
                accept=".protein.faa.gz,.faa.gz"
              >
                <div
                  class="sequence-item"
                  :class="{ fontColor: form.proteinSequence }"
                >
                  <div
                    class="sequence-item-loading"
                    v-if="loading.proteinSequence"
                  >
                    <span>文件上传中</span>
                    <i class="el-icon-loading"></i>
                  </div>
                  <div class="text-item" v-if="!loading.proteinSequence">
                    <span>{{
                      form.proteinSequence || '.protein.faa.gz或.faa.gz'
                    }}</span>
                    <i
                      v-if="form.proteinSequence"
                      class="el-icon-close"
                      @click.stop="delSequence('proteinSequence')"
                    ></i>
                  </div>
                </div>
              </el-upload> </el-form-item
          ></el-col>
        </el-row>
        <h3 class="mar-top">
          annotation
          <el-tooltip
            class="item"
            effect="dark"
            content="此操作不可取消"
            placement="top"
          >
            <svg
              t="1647932228140"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="4861"
              width="16"
              height="16"
            >
              <path
                d="M512 64a448 448 0 1 0 448 448 448 448 0 0 0-448-448z m3.2 704a48 48 0 0 1-48-47.36 48.64 48.64 0 0 1 48-48 48 48 0 0 1 47.36 48 47.36 47.36 0 0 1-47.36 47.36z m80.64-271.36A131.84 131.84 0 0 0 547.84 576v32a33.28 33.28 0 0 1-64 0v-24.32a181.76 181.76 0 0 1 67.2-120.32 165.76 165.76 0 0 0 60.16-104.96 83.2 83.2 0 0 0-90.24-89.6c-64 0-99.84 41.6-101.76 119.68a32 32 0 0 1-31.36 28.8 31.36 31.36 0 0 1-30.72-28.8V384a154.24 154.24 0 0 1 163.84-166.4 135.04 135.04 0 0 1 147.2 140.8 196.48 196.48 0 0 1-72.32 138.24z"
                p-id="4862"
              ></path>
            </svg>
          </el-tooltip>
        </h3>
        <el-row>
          <el-col :span="8">
            <el-form-item
              label="cog_Kog"
              :label-width="formLabelWidth"
              class="sequence mar-right"
            >
              <el-upload
                class="upload-demo"
                action="/"
                :auto-upload="false"
                :on-change="fileHandleChange"
                :show-file-list="false"
                :disabled="
                  loading.cogKogSequence || form.cogKogSequence.length !== 0
                "
                :accept="suffixList[3]"
              >
                <div
                  class="sequence-item"
                  :class="{ fontColor: form.cogKogSequence }"
                >
                  <div
                    class="sequence-item-loading"
                    v-if="loading.cogKogSequence"
                  >
                    <span>文件上传中</span>
                    <i class="el-icon-loading"></i>
                  </div>
                  <div class="text-item" v-if="!loading.cogKogSequence">
                    <span>{{ form.cogKogSequence || suffixList[3] }}</span>
                    <i
                      v-if="form.cogKogSequence"
                      class="el-icon-close"
                      @click.stop="delSequence('cogKogSequence')"
                    ></i>
                  </div>
                </div>
              </el-upload> </el-form-item
          ></el-col>
          <el-col :span="8">
            <el-form-item
              label="go"
              :label-width="formLabelWidth"
              class="sequence mar-right mar-left"
            >
              <el-upload
                class="upload-demo"
                action="/"
                :auto-upload="false"
                :on-change="fileHandleChange"
                :show-file-list="false"
                :disabled="loading.goSequence || form.goSequence.length !== 0"
                :accept="suffixList[4]"
              >
                <div
                  class="sequence-item"
                  :class="{ fontColor: form.goSequence.length }"
                >
                  <div class="sequence-item-loading" v-if="loading.goSequence">
                    <span>文件上传中</span>
                    <i class="el-icon-loading"></i>
                  </div>
                  <div class="text-item" v-if="!loading.goSequence">
                    <span>{{ form.goSequence || suffixList[4] }}</span>
                    <i
                      v-if="form.goSequence"
                      class="el-icon-close"
                      @click.stop="delSequence('goSequence')"
                    ></i>
                  </div>
                </div>
              </el-upload> </el-form-item
          ></el-col>
          <el-col :span="8">
            <el-form-item
              label="kegg"
              :label-width="formLabelWidth"
              class="sequence mar-left"
            >
              <el-upload
                class="upload-demo"
                action="/"
                :auto-upload="false"
                :on-change="fileHandleChange"
                :show-file-list="false"
                :disabled="
                  loading.keggSequence || form.keggSequence.length !== 0
                "
                :accept="suffixList[5]"
              >
                <div
                  class="sequence-item"
                  :class="{ fontColor: form.keggSequence }"
                >
                  <div
                    class="sequence-item-loading"
                    v-if="loading.keggSequence"
                  >
                    <span>文件上传中</span>
                    <i class="el-icon-loading"></i>
                  </div>
                  <div class="text-item" v-if="!loading.keggSequence">
                    <span>{{ form.keggSequence || suffixList[5] }}</span>
                    <i
                      v-if="form.keggSequence"
                      class="el-icon-close"
                      @click.stop="delSequence('keggSequence')"
                    ></i>
                  </div>
                </div>
              </el-upload> </el-form-item
          ></el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item
              label="nr"
              :label-width="formLabelWidth"
              class="sequence mar-right"
            >
              <el-upload
                class="upload-demo"
                action="/"
                :auto-upload="false"
                :on-change="fileHandleChange"
                :show-file-list="false"
                :disabled="loading.nrSequence || form.nrSequence.length !== 0"
                :accept="suffixList[6]"
              >
                <div
                  class="sequence-item"
                  :class="{ fontColor: form.nrSequence }"
                >
                  <div class="sequence-item-loading" v-if="loading.nrSequence">
                    <span>文件上传中</span>
                    <i class="el-icon-loading"></i>
                  </div>
                  <div class="text-item" v-if="!loading.nrSequence">
                    <span>{{ form.nrSequence || suffixList[6] }}</span>
                    <i
                      v-if="form.nrSequence"
                      class="el-icon-close"
                      @click.stop="delSequence('nrSequence')"
                    ></i>
                  </div>
                </div>
              </el-upload> </el-form-item
          ></el-col>
          <el-col :span="8">
            <el-form-item
              label="nt"
              :label-width="formLabelWidth"
              class="sequence mar-right mar-left"
            >
              <el-upload
                class="upload-demo"
                action="/"
                :auto-upload="false"
                :on-change="fileHandleChange"
                :show-file-list="false"
                :disabled="loading.ntSequence || form.ntSequence.length !== 0"
                :accept="suffixList[7]"
              >
                <div
                  class="sequence-item"
                  :class="{ fontColor: form.ntSequence }"
                >
                  <div class="sequence-item-loading" v-if="loading.ntSequence">
                    <span>文件上传中</span>
                    <i class="el-icon-loading"></i>
                  </div>
                  <div class="text-item" v-if="!loading.ntSequence">
                    <span>{{ form.ntSequence || suffixList[7] }}</span>
                    <i
                      v-if="form.ntSequence"
                      class="el-icon-close"
                      @click.stop="delSequence('ntSequence')"
                    ></i>
                  </div>
                </div>
              </el-upload> </el-form-item
          ></el-col>
          <el-col :span="8">
            <el-form-item
              label="swissprot"
              :label-width="formLabelWidth"
              class="sequence mar-left"
            >
              <el-upload
                class="upload-demo"
                action="/"
                :auto-upload="false"
                :on-change="fileHandleChange"
                :show-file-list="false"
                :disabled="loading.swSequence || form.swSequence.length !== 0"
                :accept="suffixList[8]"
              >
                <div
                  class="sequence-item"
                  :class="{ fontColor: form.swSequence }"
                >
                  <div class="sequence-item-loading" v-if="loading.swSequence">
                    <span>文件上传中</span>
                    <i class="el-icon-loading"></i>
                  </div>
                  <div class="text-item" v-if="!loading.swSequence">
                    <span>{{ form.swSequence || suffixList[8] }}</span>
                    <i
                      v-if="form.swSequence"
                      class="el-icon-close"
                      @click.stop="delSequence('swSequence')"
                    ></i>
                  </div>
                </div> </el-upload></el-form-item
          ></el-col>
        </el-row>
        <!-- 批量添加 -->
        <el-row
          ><el-col :span="24">
            <el-form-item
              label=""
              :label-width="formLabelWidth"
              class="add-sequence"
            >
              <div class="add-box">
                <el-upload
                  class="upload-demo"
                  action="/"
                  :auto-upload="false"
                  :on-change="fileHandleMoreChange"
                  :show-file-list="false"
                  :disabled="!form.sequence"
                  accept="
                    .genomic.fna.gz,
                    .cds.fna.tar.gz,
                    .ffn.tar.gz,
                    .protein.faa.gz,
                    .faa.gz,
                    .COG_KOG.zip,
                    .GO.zip,
                    .KEGG.zip,
                    .NR.zip,
                    .NT.zip,
                    .swissprot.zip
                  "
                  multiple
                >
                  <el-link
                    class="sequence-item"
                    type="primary"
                    :underline="false"
                    >Batch add</el-link
                  >
                </el-upload>
                <el-tooltip class="item" effect="dark" placement="top">
                  <div
                    slot="content"
                    class="tip-mes"
                    v-for="item in tip"
                    :key="item"
                  >
                    {{ item }}<br />
                  </div>
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmClick">确 定</el-button>
        <el-button @click="closeWindow">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Message } from 'element-ui'
import api from '@/utils/api'
export default {
  name: 'ModifyStrain',
  props: {
    obj: {
      type: Object,
      default: null
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      dialogVisible: true,
      titleName: this.title,
      data: this.obj,
      form: {
        strainName: '',
        serialCode: '',
        sequence: true,
        genomeSequence: '',
        gdsSequence: '',
        proteinSequence: '',
        cogKogSequence: '',
        goSequence: '',
        keggSequence: '',
        nrSequence: '',
        ntSequence: '',
        swSequence: ''
      },
      suffixList: [
        '.genomic.fna.gz',
        '.cds.fna.tar.gz',
        '.protein.faa.gz',
        '.COG_KOG.zip',
        '.GO.zip',
        '.KEGG.zip',
        '.NR.zip',
        '.NT.zip',
        '.swissprot.zip',
        '.ffn.tar.gz',
        '.faa.gz'
      ],
      tip: [
        'genomic suffix is .genomic.fna.gz',
        'cds suffix is .cds.fna.tar.gz、.ffn.tar.gz',
        'protein suffix is .protein.faa.gz、.faa.gz',
        'cog_kog suffix is .COG_KOG.zip',
        'go suffix is .GO.zip',
        'kegg suffix is .KEGG.zip',
        'nr suffix is .NR.zip',
        'nt suffix is .NT.zip',
        'swissprot suffix is .swissprot.zip'
      ],
      formLabelWidth: '100px',
      fileList: [],
      fileRaw: {
        genomeSequence: null,
        gdsSequence: null,
        proteinSequence: null,
        cogKogSequence: null,
        goSequence: null,
        keggSequence: null,
        nrSequence: null,
        ntSequence: null,
        swSequence: null
      },
      newBuild: null,
      strainId: null,
      nameList: null,
      loading: {
        genomeSequence: false,
        gdsSequence: false,
        proteinSequence: false,
        cogKogSequence: false,
        goSequence: false,
        keggSequence: false,
        nrSequence: false,
        ntSequence: false,
        swSequence: false
      },
      strainDatabaseId: ''
    }
  },
  created () {
    if (this.obj === null) {
      this.newBuild = true
    } else {
      this.newBuild = false
      this.strainId = this.data.annotationId
      this.getSequence('strainName')
      this.getSequence('serialCode')
      this.getSequence('genomeSequence')
      this.getSequence('gdsSequence')
      this.getSequence('proteinSequence')
      this.getSequence('cogKogSequence')
      this.getSequence('goSequence')
      this.getSequence('keggSequence')
      this.getSequence('nrSequence')
      this.getSequence('ntSequence')
      this.getSequence('swSequence')
    }
    this.getSettingData()
  },
  methods: {
    async getSettingData () {
      let url = '../../static/geneIdSetting.json'
      try {
        let response = await fetch(url)
        let obj = await response.json()
        this.strainDatabaseId = obj.strainDatabaseId
      } catch (error) {
        // console.log('Request Failed', error)
      }
    },
    getSequence (val) {
      if (this.data[val] !== null) {
        this.form[val] = this.data[val]
      } else {
        this.form[val] = ''
      }
    },
    // 上传单个文件
    fileHandleChange (file) {
      /* eslint-disable */
      let reg1 = new RegExp('\.genomic\.fna\.gz$')
      let reg2 = new RegExp('\.cds\.fna\.gz$|\.ffn\.gz$')
      let reg3 = new RegExp('\.protein\.faa\.gz$|\.faa\.gz$')
      let reg4 = new RegExp('\.COG_KOG\.zip$')
      let reg5 = new RegExp('\.GO\.zip$')
      let reg6 = new RegExp('\.KEGG\.zip$')
      let reg7 = new RegExp('\.NR\.zip$')
      let reg8 = new RegExp('\.NT\.zip$')
      let reg9 = new RegExp('\.swissprot\.zip$')
      /* eslint-disable */
      switch (true) {
        case reg1.test(file['name']):
          this.confirmFile(
            'genomic',
            file['name'],
            'genomeSequence',
            file['raw']
          )
          break
        case reg2.test(file['name']):
          this.confirmFile('cds', file['name'], 'gdsSequence', file['raw'])
          break
        case reg3.test(file['name']):
          this.confirmFile(
            'protein',
            file['name'],
            'proteinSequence',
            file['raw']
          )
          break
        case reg4.test(file['name']):
          this.confirmFile(
            'cog_Kog',
            file['name'],
            'cogKogSequence',
            file['raw']
          )
          break
        case reg5.test(file['name']):
          this.confirmFile('go', file['name'], 'goSequence', file['raw'])
          break
        case reg6.test(file['name']):
          this.confirmFile('kegg', file['name'], 'keggSequence', file['raw'])
          break
        case reg7.test(file['name']):
          this.confirmFile('nr', file['name'], 'nrSequence', file['raw'])
          break
        case reg8.test(file['name']):
          this.confirmFile('nt', file['name'], 'ntSequence', file['raw'])
          break
        case reg9.test(file['name']):
          this.confirmFile('swissprot', file['name'], 'swSequence', file['raw'])
          break
        case 3:
          Message.error(`${file['name']}类型匹配不到`)
          break
        default:
      }
    },
    // 确认是否含有文件
    confirmFile(typeName, fileName, xl, fileRaw) {
      if (this.form[xl].length !== 0) {
        Message(`${typeName}已有序列存在`)
      } else {
        this.form[xl] = fileName
        this.fileRaw[xl] = fileRaw
        if (!this.newBuild) {
          this.loading[xl] = true
          this.checkFileByAnnotation(xl)
        }
      }
    },
    // 上传多个文件
    fileHandleMoreChange(file, fileArr) {
      this.fileList = fileArr
    },
    getFileList(list) {
      list.forEach(ele => {
        this.fileHandleChange(ele)
      })
    },
    // 删除序列
    delSequence(val) {
      // 请求数据
      if (!this.newBuild) {
        this.deleteFileByAnnotationName(val)
      } else {
        this.form[val] = ''
        this.fileRaw[val] = null
      }
    },
    // 删除文件
    deleteFileByAnnotationName(val) {
      api
        .deleteFileByAnnotationName(this.form[val], this.strainId)
        .then(res => {
          if (res.data.code === 200) {
            this.form[val] = ''
            this.fileRaw[val] = null
            Message.success(`${res.data.msg}`)
          } else {
            Message.error(`${res.data.msg}`)
          }
        })
    },
    // 关掉弹窗
    closeWindow() {
      this.$emit('closeModify')
    },
    // 确认按钮
    confirmClick() {
      if (this.form.strainName && this.form.serialCode) {
        if (this.newBuild === true) {
          this.annotationInsert()
        } else {
          this.modifyByStrain()
        }
      } else {
        Message('请填写必填项')
        return false
      }
    },
    // 添加毒株
    annotationInsert() {
      let obj = {}
      obj['strainName'] = this.form['strainName']
      obj['serialCode'] = this.form['serialCode']
      api.annotationInsert(obj).then(res => {
        if (res.data.code === 200) {
          this.strainId = res.data.data
          this.checkFileByAnnotation()
        } else {
          Message.error(`${res.data.msg}`)
        }
      })
    },
    // 毒株文件查重
    checkFileByAnnotation(val = null) {
      this.nameList = []
      if (val) {
        this.nameList.push(this.form[val])
      } else {
        this.form['genomeSequence'] &&
          this.nameList.push(this.form['genomeSequence'])
        this.form['gdsSequence'] && this.nameList.push(this.form['gdsSequence'])
        this.form['proteinSequence'] &&
          this.nameList.push(this.form['proteinSequence'])
        this.form['cogKogSequence'] &&
          this.nameList.push(this.form['cogKogSequence'])
        this.form['goSequence'] && this.nameList.push(this.form['goSequence'])
        this.form['keggSequence'] &&
          this.nameList.push(this.form['keggSequence'])
        this.form['nrSequence'] && this.nameList.push(this.form['nrSequence'])
        this.form['ntSequence'] && this.nameList.push(this.form['ntSequence'])
        this.form['swSequence'] && this.nameList.push(this.form['swSequence'])
      }
      if (this.nameList.length !== 0) {
        api.checkFileByAnnotation(this.strainId, this.nameList).then(res => {
          if (res.data.code === 200) {
            if (res.data.data.length === 0) {
              // 无重复，上传文件
              this.classifyAndUploading(val)
            }
          } else {
            if (val) {
              this.loading[val] = false
            }
            Message.error(`${res.data.msg}`)
          }
        })
      } else {
        Message.success('添加成功')
        this.closeWindow()
      }
    },
    // 文件上传
    classifyAndUploading(val = null) {
      let FileRaw = new FormData()
      if (val) {
        FileRaw.append('files', this.fileRaw[val])
      } else {
        Object.keys(this.fileRaw).forEach(key => {
          if (this.fileRaw[key]) {
            FileRaw.append('files', this.fileRaw[key])
          }
        })
      }
      if (this.strainDatabaseId) {
        api.classifyAndUploading(this.strainDatabaseId, FileRaw).then(res => {
          if (res.data.code === 200) {
            this.updataAnnotationFile(res.data.data, val)
          } else {
            if (val) {
              this.fileRaw[val] = null
              this.form[val] = null
              this.loading[val] = false
            } else {
              Object.keys(this.fileRaw).forEach(key => {
                if (this.fileRaw[key]) {
                  this.fileRaw[key] = null
                  this.form[key] = null
                }
              })
            }
            Message.error(`${res.data.msg}`)
          }
        })
      } else {
        Message.error('找不到数据库id')
      }
    },
    // 更新毒株信息
    updataAnnotationFile(details, val = null) {
      api.updataAnnotationFile(this.strainId, details).then(res => {
        if (res.data.code === 200) {
          Message.success('添加成功')
          if (this.newBuild) {
            this.closeWindow()
          }
        } else {
          Message.error(`${res.data.msg}`)
        }

        if (val) {
          this.loading[val] = false
        }
      })
    },
    // 修改毒株
    modifyByStrain() {
      let obj = {}
      obj['annotationId'] = this.data['annotationId']
      obj['strainName'] = this.form['strainName']
      obj['serialCode'] = this.form['serialCode']
      api.modifyByStrain(obj).then(res => {
        if (res.data.code === 200) {
          Message.success(`${res.data.msg}`)
          if (!this.newBuild) {
            this.closeWindow()
          }
        } else {
          Message.error(`${res.data.msg}`)
        }
      })
    }
  },
  watch: {
    fileList: 'getFileList',
    form: {
      handler: function(newal, oldal) {
        let a = 0
        for (let i in newal) {
          if (i !== 'strainName' && i !== 'serialCode' && i !== 'sequence') {
            if (newal[i]) {
              a++
            }
          }
        }
        if (a === 9) {
          this.form['sequence'] = false
        } else {
          this.form['sequence'] = true
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.modify-strain {
  .el-dialog__wrapper >>> .el-dialog__body {
    padding: 10px 40px 10px 20px;
  }
  .el-dialog__wrapper >>> .el-dialog__footer {
    padding-top: 10px;
  }
  .el-form-item {
    margin-bottom: 20px;
    >>> .el-form-item__label {
      padding: 0;
    }
    >>> .el-form-item__content {
      .el-input {
        .el-input__inner {
          color: #333;
        }
      }
    }
  }
  .address {
    >>> .el-form-item__content {
      display: flex;
      justify-content: space-between;
      .el-input {
        margin-right: 10px;
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
  .sequence {
    margin-bottom: 20px;
    >>> .el-form-item__content {
      margin-left: 0 !important;
      display: flex;
    }
    .upload-demo {
      width: 100%;
      >>> .el-upload {
        text-align: left;
        width: 100%;
        .sequence-item {
          padding: 0 15px;
          box-sizing: border-box;
          width: 100%;
          border: 1px solid #dcdfe6;
          border-radius: 4px;
          color: rgb(222, 223, 228);
          .sequence-item-loading {
            color: #409eff;
            .el-icon-loading {
              color: #409eff;
            }
          }
          .text-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            span {
              margin-left: 0;
            }
            i {
              color: #999;
              &:hover {
                color: $theme_color;
              }
            }
          }
          &:hover {
            border-color: #c0c4cc;
          }
        }
      }
    }
    span {
      margin-left: 5px;
    }
  }
  .add-sequence {
    margin: 0;
    line-height: 30px;
    .add-box {
      background: #ffffff;
      line-height: 30px;
      display: flex;
      align-items: center;
      >>> .el-link--inner {
        margin-right: 8px;
        font-size: 14px;
        line-height: 30px;
      }
      i {
        font-size: 14px;
        color: #666;
        &:hover {
          color: $theme_color;
        }
      }
    }
  }
  .el-input.is-active >>> .el-input__inner,
  >>> .el-input__inner:focus,
  .el-button--primary:focus,
  .el-button--primary:hover {
    border-color: $theme_color;
  }
  .el-button {
    width: 80px;
    height: 34px;
    border-radius: 2px;
    background: #fff;
  }
  .el-button--primary {
    background: $theme_color;
    border-color: $theme_color;
  }
  .el-date-editor {
    width: 100%;
  }
  .fontColor {
    color: #333 !important;
  }
  .mar-top {
    margin-top: 10px;
    display: flex;
    align-items: center;
    svg {
      margin-left: 5px;
      path {
        fill: #666;
      }
      &:hover {
        path {
          fill: $theme_color;
        }
      }
    }
  }
  .mar-right {
    margin-right: 15px;
  }
  .mar-left {
    margin-left: 15px;
  }
  .require {
    position: relative;
    &::after {
      content: '*';
      color: #ff0000;
      position: absolute;
      bottom: -6px;
      right: -10px;
    }
  }
}
.tip-mes {
  margin: 5px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/backstage/modifyStrain.vue